import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ProfileComponent } from './profile/profile.component';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageAuthorizationModule } from './ph-bhp-feature-package-authorization.module';
import { ProfileModule } from 'profile';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
 
 
// common libraries


@NgModule({
  declarations: [ 
    LoginComponent,
    ForgetPasswordComponent,
    UserRegistrationComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    ProfileComponent, 
   
  ],
  imports: [
    ProfileModule,
    CommonModule,
    PHBHPLocalizePackageModule,
    PHBHPLayoutPackageModule,
    PHBHPFeaturePackageAuthorizationModule,
    PhBhpUiModule
  ],
})
export class AuthorizationModule { }
